import "../../stylesheets/App.css";
import "../../stylesheets/PopupRegister.css";
import React from "react";

function PopupAdminStages(props) {
  return (
    <>
      <div className="popup-register-container popup-deactivate-user popup-confirm-deactive-user popup-stage-module">
        <div className="popup">
          <div className="lightgreen">
            <button
              className="btn-close-popup"
              onClick={() => props.closeAction(props.closeValue)}
            >
              X
            </button>

            <img
              src={
                process.env.PUBLIC_URL +
                "/images/stage_characters/Popup_Imagen.png"
              }
              alt="Popup"
            />
          </div>

          <h1>{props.title}</h1>
          <h2>{props.text}</h2>

          <button
            className="btn lightgreen-btn"
            style={props.margin_0 ? { marginLeft: 0 } : {}}
            onClick={() => {
              props.action();
              props.setLoadingUpdateStages?.(true); // por si este popup se usa en otro lugar sin esa prop
            }}
          >
            Confirmar
          </button>
        </div>
      </div>
    </>
  );
}

export default PopupAdminStages;
